import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import '98.css';

createApp(App).mount('#app')
